import React,{useEffect, useState} from 'react'
import EditTableRows from './EditTableRows';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { SERVER_API } from '../../../fileWithConstants';
const EditAddDeleteTableRows= (props)=>{
    const params = useParams();
    const po_id = params.po_id;
    const [rowsData, setRowsData] = useState([]);
    const [fabrics, setFabrics] = useState(props.fabrics);
    const [subtotal, setSubtotal] = useState(0); 
    const [gst, setGst] = useState(12); 
    const [totalAmount, setTotalAmount] = useState(0); 
    const [deliveryAdd, setDeliveryAdd] = useState("");
    const [delId, setDelId] = useState("");
    const [notes, setNotes] = useState("");
    const getPodata = async()=>{
      try {
        const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-element-po/${po_id}`);
        if(data?.success && data?.podata?.length>0){
          const p_data = data?.podata[0];
          //console.log(p_data)
          setSubtotal(p_data.sub_total)
          setGst(p_data.gst)
          setTotalAmount(p_data.total)
          setNotes(p_data.notes)
          setDeliveryAdd(p_data.del_address)
          handleAddress(p_data.del_id)
          setDelId(p_data.del_id);
        }
      } catch (error) {
        console.log(error)
      }
  }


  const getPoSingledata = async()=>{
    try {
      const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-single-element-po-data/${po_id}`);
      if(data?.success && data?.posingledata?.length>0){
        
       
        const poDetailDataArr = data?.posingledata.map(item=>{
          return {
            qty:item.qty,
            price:item.price,
            unit:item.unit,
            discount:item.discount,
            amount:item.amount,
            gst:item.gst,
            name:item.fabric,
          };
        })
        console.log(poDetailDataArr)
        setRowsData(poDetailDataArr)
        props.handleRowdata(poDetailDataArr);
      
      }
    } catch (error) {
      console.log(error)
    }
}


    const addTableRows = (e)=>{
      e.preventDefault();
        const rowsInput={
            name:'',
            qty:'',
            unit:'Pcs',  
            price:'',  
            discount:0,
            amount:'',  
            gst:5
        } 
        setRowsData([...rowsData, rowsInput])
    }
   const deleteTableRows = (index)=>{
        const rowsInput = [...rowsData];
        //console.log(rows)
        //console.log(index)
        rowsInput.splice(index, 1);
        setRowsData(rowsInput);

        if(rowsInput.length>0){
          let price_arr = rowsInput.map(el=>el.amount); 
          let sum = price_arr.reduce((accumulator, currentvalue)=>{
             return accumulator+Number(currentvalue);
          },0)
         setSubtotal(sum);
         setTotalAmount(sum);
       }
   }
   
const handleChange = (index, evnt)=>{
  const { name, value } = evnt.target;
  const rowsInput = [...rowsData];

  /* if change fabric dropdown then fetch fabric details and set price */
  if(evnt.target.name=='name'){
    var fabric_id_price = evnt.target.value.split('#');
    rowsInput[index][name] = fabric_id_price[0];
    rowsInput[index]['price'] = fabric_id_price[1];
  }else{
    rowsInput[index][name] = value;
  }

  let amount_total = rowsInput[index]['qty']*rowsInput[index]['price'];
  let discount = rowsInput[index]['discount'];
  let discount_amount = ((amount_total*discount)/100);
  rowsInput[index]['amount'] = (amount_total-discount_amount);
  
  if(rowsInput.length>0){
     let price_arr = rowsInput.map(el=>el.amount); 
     let sum = price_arr.reduce((accumulator, currentvalue)=>{
        return accumulator+Number(currentvalue);
     },0)
    
    setSubtotal(sum);
    setTotalAmount(sum);
   
  }
  props.handleRowdata(rowsData);
  setRowsData(rowsInput);
  //props.handlePodata({sum,gst,sum,deliveryAdd,notes})
 
}

useEffect(()=>{
  setFabrics(props.fabrics);
})
useEffect(()=>{
  getPodata();
  getPoSingledata();
},[]);

useEffect(()=>{
  props.handlePodata({subtotal,gst,totalAmount,delId,deliveryAdd,notes});
  console.log(subtotal,gst,totalAmount,deliveryAdd,notes)
  setDeliveryAdd(deliveryAdd);
  setDelId(delId);
},[subtotal,gst,totalAmount,deliveryAdd,notes])

const handleAddress = (addId)=>{
  setDelId(addId);
  let AddArr = [{"1":"A-14, Narayana \r industrial  area \r Delhi-110028","2":"A-44 Back side, Narayana \r industrial  area \r Delhi-110028"}];
  if(addId){
    const delAdd =AddArr[0][addId]; 
    //console.log(addId)
    setDeliveryAdd(delAdd);
  }else{
    setDeliveryAdd("");
  }
}
    return(
                <div className="col-sm-12">
                  <table className="table table-responsive table-hover">
                      <thead>
                        <tr>
                          <th scope="col">Kali/Dupatta</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Unit</th>
                          <th scope="col">Price</th>
                          <th scope="col">Dis %</th>
                          <th scope="col">Amount INR</th>
                          <th scope="col">GST %</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                    <tbody>
                    <EditTableRows rowsData={rowsData} deleteTableRows={deleteTableRows} handleChange={handleChange} handleFabrics={fabrics}/>
                    </tbody> 
                  </table>

                  <div className="row">
                    <div className='col-md-4 mb-3'> 
                    <button className="btn btn-success mb-3" onClick={addTableRows} >+ Add Row</button>
                    </div>
                    <div className='col-md-8 float-end mb-3'> 
                      <p>Subtotal: {subtotal}</p>
                      <p>GST: {gst}</p>
                      <p>Total: {totalAmount}</p>
                    </div>
                    <hr/>
                    <div className='col-md-4 mb-3'>
                    <label>Delivery Address*</label>
                    <select required className='form-control mb-3' value={delId} name="del_id" onChange={(e)=>{handleAddress(e.target.value)}}>
                      <option value={""}>--Select Delivery Address--</option>
                      <option value={1}> A-14 </option>
                      <option value={2}> A-44 </option>
                    </select>

                    <textarea required cols={10} rows={3} className='form-control' name='del_address'  value={deliveryAdd} onChange={(e)=>setDeliveryAdd(e.target.value)}/>
                    </div>

                    <div className='col-md-8 mb-3'>
                    <label>Notes</label>
                    <textarea cols={15} rows={3} className='form-control' name='po_notes' value={notes} onChange={(e)=>setNotes(e.target.value)}/>
                    </div>
                  </div>

                </div>
           
    )
}
export default EditAddDeleteTableRows